import { Injectable } from '@angular/core';
import {HttpClient,HttpHeaders } from '@angular/common/http';
import {RequestOptions, ResponseContentType} from "@angular/http";
@Injectable()
export class DownloadService {

  constructor() { }


  downloadFile(data,type,fileName) {
    var blob = new Blob([data], {type:type});
    var url = window.URL.createObjectURL(blob);
    var a:any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    //window.open(url,'_blank');
  }

  print(data,type,fileName) {
    let blob = new Blob([data], {type:type});
    let url = window.URL.createObjectURL(blob);
    let a:any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    //window.open(data,'_blank');
  }

  createAuthHeader (){
    var bearerToken = localStorage.getItem('access_token');
    let headerJson = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${bearerToken}`
    };
    let headersConfig = new HttpHeaders(headerJson);

    return headersConfig;
  }

  createAuthHeaderPdf (){
    const bearerToken = localStorage.getItem('access_token');
    let headerJson = {
      'Content-Type': 'application/pdf',
      'Accept': 'application/pdf',
      'Authorization': `Bearer ${bearerToken}`,
      responseType : 'blob'
    };
    return  new HttpHeaders(headerJson);
  }
  createAuthHeaderFileUpload(){
    const bearerToken = localStorage.getItem('access_token');
    let headerJson = {
      'Authorization': `Bearer ${bearerToken}`
    };
    return headerJson; // new HttpHeaders(headerJson);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/download.service.ts